import React from "react";
import NoPublicAccess from "@components/NoPublicAccess";
import VersionedLayout from "@components/Wrappers/VersionedLayout/index.js";

const NoPublicAccessPage = () => {


    return (
        <VersionedLayout minimal>
            <NoPublicAccess />
        </VersionedLayout>
    );
};

export default NoPublicAccessPage;
